import { gsap } from "gsap"
import { ScrollTrigger } from "gsap/ScrollTrigger.js"
gsap.registerPlugin(ScrollTrigger)

class Animate {
	constructor() {
    this.initialize()
  }

  initialize() {
    this.elements = [...document.querySelectorAll('.js-animate')]
    
    this.options = {
      rootMargin: '0px',
      threshold: [...Array(100).keys()].map(x => x / 100)
    }

    this.callback = (entries) => {
      entries.forEach((entry) => {
        const delay = entry.target.getAttribute('data-delay');
        const once = entry.target.hasAttribute('data-once');

        if (delay || once) {
          this.options.threshold = 0.25
        }

        if (entry.intersectionRatio >= 0.25 && delay) {
          setTimeout(() => {
              entry.target.classList.add("is-visible");
          }, delay)
        }
        
        if (entry.intersectionRatio >= 0.25 && once) {
          entry.target.classList.add("is-visible");
          if (entry.target.classList.contains('js-animate--video')) {
            let currentVideo = entry.target.querySelector('.js-video')
            window.video.forEach(video => {
              if (video.ui.$video == currentVideo) {
                if (!video.ui.$video.muted) {
                  video.mute()
                }
              }
            });
          }
        }

        if(!delay && !once) {
          if (entry.intersectionRatio === 0) {
            // console.log('outside');
            entry.target.classList.remove("is-visible");
            if (entry.target.classList.contains('js-animate--video')) {
              let currentVideo = entry.target.querySelector('.js-video')
              window.video.forEach(video => {
                if (video.ui.$video == currentVideo) {
                  if (!video.ui.$video.muted) {
                    video.mute()
                  }
                }
              });
            }
          } else if (entry.intersectionRatio <= 0.50) {
            if (entry.boundingClientRect.top < entry.intersectionRect.top) {
              // console.log('on the top');
              entry.target.classList.remove("is-visible");
              if (entry.target.classList.contains('js-animate--video')) {
                let currentVideo = entry.target.querySelector('.js-video')
                window.video.forEach(video => {
                  if (video.ui.$video == currentVideo) {
                    if (!video.ui.$video.muted) {
                      video.mute()
                    }
                  }
                });
              }
            } else {
              // console.log('on the bottom');
              entry.target.classList.remove("is-visible");
              if (entry.target.classList.contains('js-animate--video')) {
                let currentVideo = entry.target.querySelector('.js-video')
                window.video.forEach(video => {
                  if (video.ui.$video == currentVideo) {
                    if (!video.ui.$video.muted) {
                      video.mute()
                    }
                  }
                });
              }
            }
          } else {
            // console.log('inside');
            entry.target.classList.add("is-visible");
          }
        }
      })
    }

    this.observer = new IntersectionObserver(this.callback, this.options)

    this.elements.forEach((element, index) => {
      this.observer.observe(element)
    })
  }
}

export default Animate
